import classes from "./FrequencyOptions.module.scss";

const FrequencyOptions = ({ availableFrequencies, handleFrequencyChange, frequency }) => {
  return (
    <div className={classes['options-wrapper']}>
      <select
        name="frequency-options"
        onChange={(e) => handleFrequencyChange(e.target.value)}
        value={frequency}
        className={classes['options-select']}
      >
        {availableFrequencies.map((frequencyOption) => (
          <option
            key={frequencyOption._key}
            value={frequencyOption.matchingSubscriptionGroup}
          >
            {frequencyOption.frequencyOption}
          </option>
        ))}
      </select>
    </div>
  );
};

export default FrequencyOptions;